import { STORY_EMOTE_INTERVAL_MS, STORY_EMOTES, type StoryEmote } from '@rdd/contracts'
import { t } from '../i18n/pt-BR'

/**
 * A barra de emotes (modo_historia/04#HM-002). docs/21 secao 7.
 *
 * Seis botoes em DOM, com rotulo do dicionario. O desenho de cada emote e um emoji: e simbolo, e nao texto de
 * interface, e por isso mora aqui, e nao no i18n. Depois de mandar um, a barra inteira fica indisponivel pelo
 * mesmo intervalo que o servidor aplica -- para nao deixar o jogador mandar o que o servidor vai ignorar.
 */

export const EMOTE_GLYPHS: Readonly<Record<StoryEmote, string>> = {
  wave: '👋',
  laugh: '😂',
  surprise: '😮',
  thumbs_up: '👍',
  angry: '😠',
  heart: '❤️',
}

export function emoteBar(
  onEmote: (id: StoryEmote) => void,
  schedule: (ms: number, run: () => void) => void = (ms, run) => void setTimeout(run, ms),
): HTMLElement {
  const bar = document.createElement('div')
  bar.className = 'emotes'
  bar.setAttribute('role', 'toolbar')
  bar.setAttribute('aria-label', t.emotes.bar)

  const buttons = STORY_EMOTES.map((id) => {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'emote'
    button.textContent = EMOTE_GLYPHS[id]
    button.setAttribute('aria-label', t.emotes[id])
    button.title = t.emotes[id]
    button.addEventListener('click', () => {
      onEmote(id)
      for (const other of buttons) other.disabled = true
      schedule(STORY_EMOTE_INTERVAL_MS, () => {
        for (const other of buttons) other.disabled = false
      })
    })
    return button
  })
  bar.append(...buttons)
  return bar
}
